




















import Vue, { PropType } from "vue";

// Vue components
import WidgetCard from "../WidgetCard.vue";

// Model
import { DashboardWidget } from "@/model/data/dashboard/DashboardWidget";
import { WidgetTypesEnum } from "@/model/data/dashboard/WidgetTypesEnum";

export default Vue.extend({
    components: {
        WidgetCard,
    },
    data() {
        return {
            livePreviewEnabled: true,
            localWidget: null,
        };
    },
    props: {
        widget: Object as PropType<DashboardWidget>,
    },
    computed: {
        canDoLivePreview() {
            return (
                (this.widget as DashboardWidget).widgetType != WidgetTypesEnum.CashCount &&
                (this.widget as DashboardWidget).widgetType != WidgetTypesEnum.Transactions &&
                (this.widget as DashboardWidget).widgetType != WidgetTypesEnum.InstallationsStatusChanges
            );
        },
        canRenderWidgetCard() {
            return (this.livePreviewEnabled && this.canDoLivePreview && this.widget) || this.localWidget;
        },
    },
    watch: {
        widget: {
            handler(newValue) {
                if (this.livePreviewEnabled && this.canDoLivePreview) this.fetchWidgetData(null);
            },
            deep: true,
        },
    },
    methods: {
        onRefresh() {
            this.localWidget = this.widget.clone();
            this.fetchWidgetData(this.localWidget);
        },

        fetchWidgetData(widget: DashboardWidget) {
            if (this.$refs.widgetCard) this.$refs.widgetCard.fetchWidgetData(widget);
        },
    },
    mounted() {
        this.localWidget = this.widget.clone();
    },
});
